// src/hooks/useAuth.js
import { useContext } from 'react';
import { AuthContext } from '../context/AuthContext'

// Hook personalizado para usar el contexto de autenticación
const useAuth = () => {
  return useContext(AuthContext);
};

export default useAuth;
